import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from 'gsap/SplitText';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { end } from "@popperjs/core";


gsap.registerPlugin(ScrollTrigger, ScrollSmoother,MotionPathPlugin,ScrollToPlugin,SplitText,DrawSVGPlugin);

let smoother  = ScrollSmoother.create({
  target: "#smooth-content",         // can be any element (selector text is fine)    // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
  smooth: 1.5,    
  effects: true,
  normalizeScroll:true,   // looks for data-speed and data-lag attributes on elements
});

gsap.to(window, {
  duration: 0,
  scrollTo: 0
});
smoother.paused(true);

let isMobile = false;
const ios = () => {
    if (typeof window === `undefined` || typeof navigator === `undefined`) return false;
    return /iPhone|iPad|iPod/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`));
};




const home = document.querySelector(".page-template-fullwidthpage");
const contact = document.querySelector(".page-template-contact");
const historique = document.querySelector(".page-template-historique");



if (ScrollTrigger.isTouch !== 1) {
	
	

/*   console.log('desktop'); */

}else{
  isMobile = true;
  //smoother.kill();

  document.body.classList.add('no-scroll');

	if (ios()) {
/*     console.log('IOS'); */
	}else
  {
/*     console.log('AUTRE') */
	}
}



if(home !== null)
{
 


  // Loading percent
  var current_progress = 0,
  step = 0.5; // the smaller this is the slower the progress bar

  const elem = document.querySelector('#loading .percent');
  var interval = setInterval(function() {
    current_progress += step;
    var progress = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000;
    
    updatePercent(parseInt(progress));
    if (progress >= 96) {
      clearInterval(interval);
      const elemLoading = document.querySelector('#loading');
      const elem = document.querySelector('#loading .percent');
      elem.innerHTML = "100%"; 
      gsap.timeline({})
          .to('.wrapperloading',{duration:0.5,opacity:0,ease:'Power4.Out'},0)
          .to('#loading',{duration:0.5,opacity:0,ease:'Power4.Out'},0.2)
          .to('#loading',{duration:0.1,y:'100%'},0.7);
      elemLoading.classList.add('finished');
      smoother.paused(false);
      if(isMobile)
        document.body.classList.remove('no-scroll');
      gsap.to('#openMenuButton',{opacity:1, delay:3,ease:"Power1.easeInOut",duration:0.5},0);    
    } else if (progress >= 70) {
      step = 0.1
    }
  }, 100); 

  function updatePercent(progress) {
    if (progress<=9)
      elem.innerHTML = "0"+progress + "%";
    else
      elem.innerHTML = progress + "%";
  } 

}
else{
  /* toutes les autres pages */
  smoother.paused(false);
  if(isMobile)
    document.body.classList.remove('no-scroll');

    gsap.to('#openMenuButton',{opacity:1, ease:"Power1.easeInOut",duration:0.5},0);

}


  

document.addEventListener('DOMContentLoaded', function (event) {
    window.addEventListener("load", function(e){



      function loadingEnd() {

     /*    console.log('end loading'); */

        gsap.to(window, {
          duration: 0.01,
          scrollTo: 0,
        });
        
        clearInterval(interval);
        const elem = document.querySelector('#loading .percent');
        const elemLoading = document.querySelector('#loading');
        elem.innerHTML = "100%"; 

         setTimeout(() => {
          gsap.timeline({})
          .to('.wrapperloading',{duration:0.5,opacity:0,ease:'Power4.Out'},0)
          .to('#loading',{duration:0.5,opacity:0,ease:'Power4.Out'},0.2)
          .to('#loading',{duration:0.1,y:'100%'},0.7);

          

          animTitleIntro.paused(false);
          setTimeout(() => {
            elemLoading.classList.add('finished');
            smoother.paused(false);
            if(isMobile)
              document.body.classList.remove('no-scroll');
            gsap.to('#openMenuButton',{opacity:1, delay:3,ease:"Power1.easeInOut",duration:0.5},0);
          }, "1000");
        }, "1000"); 
      } 



        let debug = false;

        /* ################################################################################### */
        /* ##############          Gestion des animations génériques       ################### */
        /* ################################################################################### */

        let globalDuration = 0.7;
        let globalOffset = 100;

        const fromBottom = gsap.utils.toArray(".from-bottom");
        const scaleIn = gsap.utils.toArray(".scaleIn");

	
        // From Bottom
        fromBottom.forEach((item, index) => {
          let delay = (typeof item.dataset.delay === 'undefined')?0:item.dataset.delay;
          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: item,
              start: "top bottom-=150px",
              end: "bottom bottom",
              markers: debug,
              toggleActions: "play none resume reverse",
            }
          });
          if(isMobile)
            tl.from(item, {y: 50, duration: globalDuration, delay:delay});
          else
            tl.from(item, {y: 50,autoAlpha: 0, duration: globalDuration, delay:delay});
        });
		
    
        // Scale In
        scaleIn.forEach((item, index) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: "top bottom",
                    end: "bottom top",
                    markers: debug,
                    toggleActions: "play none resume reverse",
                    scrub : true
                }
            });
            tl.to(item, {scale: 1.4, transformOrigin:'center center', duration: globalDuration});
        });


        /* Code s'exécutant uniquement sur la page d'accueil */
        if ( home !== null ) {

            const entranceTitle = gsap.utils.toArray("h1:not(.assortiments-title)");


            // Entrance title
            entranceTitle.forEach((item, index) => {

                if(!item.classList.contains('no-anim')) {
                  let delay = (typeof item.dataset.delay === 'undefined')?0:item.dataset.delay;

                  if(isMobile)
                    var splitText = new SplitText(item, {type: "words"});
                  else
                    var splitText = new SplitText(item, {type: "chars,words"});
                  
                  let tl = gsap.timeline({
                      scrollTrigger: {
                          trigger: item,
                          start: "top bottom-=150px",
                          end: "bottom bottom",
                          markers: debug,
                          toggleActions: "play none resume reverse",
                      }
                  });

                  if(isMobile)
                    tl.from(splitText.words, {duration: 0.2, opacity:0, y:20, stagger: .1,  ease: 'power2.In'}); 
                  else
                    tl.from(splitText.chars, {duration: 0.32, opacity:0, y:30, stagger: .02,  ease: 'power4.In'}); 
                  
                }

            });


            // #############INTRO###############
            // Create video element (INTRO)
            let video = document.createElement('video');
            const w = document.getElementById('vidIntroWrapper');
            var baseUrlIntro = w.dataset.baseurl;
            let src = (isMobile)?baseUrlIntro+'intro_m2.mp4':baseUrlIntro+'output_960_3.mp4';
            let webmSupport = 0;

            video.autoplay = false;
            video.controls = false;
            video.muted = true;
            video.preload = 'auto';
            
            //video.height = 240; // in px
            //video.width = 320; // in px

            if(isMobile){
              var img = new Image();
              img.src = baseUrlIntro+'no-support.jpg';
              
              img.onload = function(){
                video.poster = img.src;
                loadingEnd();
              }
            }else
            {
              if (video.canPlayType('video/webm')) {
                video.src = src;
                webmSupport = 1;
          /*       console.log('webmSupport =1'); */
              } else {
                var img = new Image();
                img.src = baseUrlIntro+'no-support.jpg';
                
                img.onload = function(){
                  video.poster = img.src;
                  loadingEnd();
                }
           /*      console.log('webmSupport =0'); */
              }
            }

            

            video.classList.add('h-100','w-100','video-background');
            // Include in HTML as child of box
            w.appendChild(video);

            if(isMobile) 
              var animationDuration = 2500;
            else
              var animationDuration = (webmSupport)?4500:2500;

            let startbtn = document.querySelector("#scrollToStart .startText");

            let animationStart = gsap.timeline()
                .to(".startText",{duration:0.2,color:"rgba(255,255,255,1)"})
                .to("path.downIndicator",{duration:0.2,fill:"rgba(255,255,255,1)"});
            animationStart.paused(true);
            startbtn.addEventListener("mouseenter", () => animationStart.play());
            startbtn.addEventListener("mouseleave", () => animationStart.reverse());



            document.querySelectorAll("#menu a").forEach((item, index) => {
              item.addEventListener("click", (event) => {
                // Prevent the default action
                event.preventDefault();
                let target = event.target;
                let hash = target.hash;
            
           /*      console.log(hash); */
            
                gsap.to(window, {
                  duration: 1,
                  scrollTo: hash,
                  ease: "Power1.easeInOut"
                });
              });
            });



            startbtn.addEventListener("click",(event) => {
              // Prevent the default action
              event.preventDefault();
              let target = event.target;
              let hash = target.hash;
          
      /*         console.log(hash); */
          
              gsap.to(window, {
                duration: 1,
                scrollTo: hash,
                ease: "Power1.easeInOut"
              });

            });

            startbtn.addEventListener("touchstart",() => {
              // Prevent the default action
              event.preventDefault();
              let target = event.target;
              let hash = target.hash;
         /*  
              console.log(hash); */
          
              gsap.to(window, {
                duration: 1,
                scrollTo: hash,
                ease: "Power1.easeInOut"
              });
            });

            gsap.set(".startbtnFill",{drawSVG: "0% 0%"});
            // Circle scroll Start
            let tlWelcome1 = gsap.timeline({
                scrollTrigger:{
                trigger: "#intro",
                endTrigger:"#intro",
                start: "top top",
                end: "+"+animationDuration,
                scrub: true
                }
            }).to(".startbtnFill", {transformOrigin:"center center", drawSVG: "100% 0%"});

            // animation du start | hover
            gsap.set("path.downIndicator",{opacity:1,y:-15});
            var tlp1 = gsap.timeline({repeat: -1, repeatDelay: 0, delay:0.5});
            tlp1.to("path.downIndicator", {scale:1.1, opacity:0, y:20, transformOrigin:"center center",duration:2,ease: "Power2.out"});



            let titleIntro = document.getElementById('titleWell');
            var splitTititle = new SplitText(titleIntro, {type: "chars,words"});
            var animTitleIntro = gsap.timeline({paused:true,delay:0.5}).from(splitTititle.chars, {duration: 0.44, opacity:0, y:30, stagger: .026,  ease: 'power4.In'}); 

            let intro = document.getElementById("intro");
            
            var pinDuration = (animationDuration-intro.offsetHeight);

            /* INTRO */
            const introTL =  gsap.timeline({
                scrollTrigger: {
                    trigger: "#intro",
                    start: "top top",
                    end: "+"+animationDuration,
                    scrub: 1,
                    markers: debug, 
                }
            });      
            
            const introTL2 =  gsap.timeline({
              scrollTrigger: {
                  trigger: "#intro",
                  start: "top top",
                  end: "+150",
                  scrub: 1,
                  markers: debug, 
              }
          }).to('#intro #vidIntroWrapper',{filter:"contrast(1) brightness(1) blur(0px)",scale:1,ease:"Power1.In"},0)
            .to('#intro .titleIntro',{opacity:0,ease:"Power1.In"},0); 

        

            /* Make sure the video is 'activated' on iOS */
            function once(el, event, fn, opts) {
                var onceFn = function (e) {
                    el.removeEventListener(event, onceFn);
                    fn.apply(this, arguments);
                };
                el.addEventListener(event, onceFn, opts);
                return onceFn;
            } 

            once(document.documentElement, "touchstart", function (e) {
                video.play();
                video.pause();
            });

            once(video, "loadedmetadata", () => {
              if(!isMobile)
              {
                if(webmSupport)
                {
                  introTL.fromTo(
                    video,
                    {currentTime: 0, ease:'none'},
                    {currentTime: video.duration || 1,ease:'none'}
                  ); 
                }
              }
            }); 

            video.onloadeddata = (event) => {

              if(!isMobile)
              {
                loadingEnd();
              }
            };


            if(!isMobile)
            {
              if(webmSupport)
              {
                setTimeout(function () {
                  /* if (window["fetch"]) {
                      fetch(src)
                      .then((response) => response.blob())
                      .then((response) => {
                          var blobURL = URL.createObjectURL(response);
                  
                          var t = video.currentTime;
                          once(document.documentElement, "touchstart", function (e) {
                              video.play();
                              video.pause();
                          });
                  
                          video.setAttribute("src", blobURL);
                          video.currentTime = t + 0.01;
                      });
                  } */
                }, 1000); 
              }
            }
            


            let tlHideShowNav = gsap.timeline({paused:true})
            .to('nav.custom-nav',{opacity:1, ease:"Power1.easeInOut",duration:1.2},0)
            .from('nav.custom-nav',{xPercent:100, ease:"Power1.easeInOut",duration:1.2},0);



            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '#intro',
                    start: "top top",
                    end: "+"+(pinDuration),
                    pin:'#wrapperIntro',
                    scrub: true,
                    markers: debug,
                    invalidateOnRefresh: true,
                    onLeave: ({progress, direction, isActive}) => 
                    {
                        tlHideShowNav.paused(false);
                        tlHideShowNav.play();
                    },
                    onEnterBack:({progress, direction, isActive}) => 
                    {
                        tlHideShowNav.reverse();
                    }
                }
            });

            function initIntro(){

              tl.clear();
              
              const container = document.querySelector('#chapitreRD .container');

              const topbot = (isMobile)?'2%':'10%';

              const animIntro = gsap.timeline().to('#intro .video-container',
              {
                  clipPath: () => 'inset('+topbot+' '+(window.innerWidth-(container.offsetWidth-24))/2+'px round 25px)',
                  ease:"Sine.easeInOut",
                  duration:3
              },
              "<3.5")
              .to('#scrollToStart',
              {
                  opacity:0,
                  y:50,
                  ease:"Power1.out",
                  duration:2
              },
              "<2.5");
              
              tl.add(animIntro);
            };

           
            ScrollTrigger.addEventListener("resize", initIntro);
            initIntro();

            /* Section Mécanique de précision */
            gsap.set('#transition03 .fullBg',{filter:"brightness(1)"});

            let clipPathRayon = "circle(100vw at 75% 50%)";

            if ( isMobile ) {
              clipPathRayon = "circle(150vw at 82% 50%)";
            }

            let tlAnimation03Pin = gsap.timeline({duration:7,
                scrollTrigger: {
                    trigger: "#transition03",
                    start: "top top",
                    end: "bottom top",
                    markers: debug,
                    pin: '#transition03Wrapper',
                    pinSpacing: true,
                    scrub:true,
                }
            })
            .to('#transition03',{clipPath: clipPathRayon, ease: "Circ.easeInOut", duration:6}, 0)
            .to('#transition03 .fullBg',{filter: "brightness(0.2)", ease: "power2.out", duration:3}, "<=4")
            .from('#transition03 .text',{autoAlpha: 0, y: 40, ease: "power2.out", duration: 1}, "<=1")
            .to('#transition03 .text',{duration:2}, "<=1");



/*         

            let tlAnimation03Parralax = gsap.timeline({
                scrollTrigger: {
                    trigger: "#transition03",
                    start: "top bottom",
                    end: "top top",
                    markers: debug,
                    scrub: true
                }
            }).from('#transition03 .fullBg',{backgroundPositionY:+10, ease:"power2.out"},0); */




            /* Animations chapitre 06 - Échappements */
            ScrollTrigger.create({
                trigger: "#chapitreAssortiments",
                start: "top top",
                end: "bottom bottom",
                markers: debug,
                pin: document.querySelector(".swiper-chapitre-assortiments"),
                pinSpacing: false,
            });

             /* Animations chapitre 08 - Art et métiers */
            let tl0801= gsap.timeline({
                scrollTrigger: {
                    trigger: '#chapitreDecoration .wrapper-video',
                    start: "top bottom",
                    end: "top top", 
                    markers: debug,
                    scrub:true,
                }
            });
            //.from('.vidADTitle',{opacity:0, scaleY:0.9, filter: "blur(5px)",duration:0.5},'<0.8');  

            
            let swiperChapitreAssortiments = document.querySelector(".swiper-chapitre-assortiments").swiper;


            let loadVidAssortiment = false;
            

            function videoAssortiment(){

              const innerContent = gsap.utils.toArray(".inner-content");
              innerContent.forEach((item, index) => {

                  /* Sticky */
                  let videoAssortiment = item.querySelector("video.play");
                  let videoAssortimentReverse = item.querySelector("video.playBack");
                  let videoAssortimentended = item.querySelector("video.mvmt");

                  // mise à jour des URL
                  if(!isMobile)
                  {
                      videoAssortiment.setAttribute("src", videoAssortiment.dataset.url);
                      videoAssortimentReverse.setAttribute("src", videoAssortimentReverse.dataset.url);
                  }

                  gsap.set(videoAssortiment,{opacity:1});
                  gsap.set(videoAssortimentReverse,{opacity:0});
                  

                  if(videoAssortimentended != null)
                  {
                      if(!isMobile)
                      {
                          videoAssortimentended.setAttribute("src", videoAssortimentended.dataset.url);
                          gsap.set(videoAssortimentended,{opacity:0});
                      }
                  }


                  // playing state
                  let videoAssortimentPlayed = false;  
                  let videoAssortimentReversePlayed = false;  
                  let currentState = 0;

                  if(!isMobile)
                  {

                      // PlayBackRate
                      videoAssortiment.playbackRate = 6;
                      videoAssortimentReverse.playbackRate = 6;

                      // duration
                      let videoAssortimentDuration = videoAssortiment.duration;  
                      let videoAssortimentReverseDuration = videoAssortimentReverse.duration;  
                      let durationAnimationTransition = 0.1;

                      // Quand une vidéo start, on cache l'autre et vis-vers-ça
                      videoAssortiment.addEventListener('play', function () { 
                          currentState = 1;
                          gsap.to(videoAssortimentReverse,{opacity:0,duration:durationAnimationTransition});
                          gsap.to(videoAssortiment,{opacity:1,duration:durationAnimationTransition});
                          // seulement si l'état "ended" existe pour cette pièce
                          if(videoAssortimentended != null)
                              gsap.to(videoAssortimentended,{opacity:0,duration:durationAnimationTransition});
                      },false);

                      videoAssortimentReverse.addEventListener('play', function () { 
                          currentState = 0;
                          gsap.to(videoAssortiment,{opacity:0,duration:durationAnimationTransition});
                          gsap.to(videoAssortimentReverse,{opacity:1,duration:durationAnimationTransition});
                          // seulement si l'état "ended" existe pour cette pièce
                          if(videoAssortimentended != null)
                          gsap.to(videoAssortimentended,{opacity:0,duration:durationAnimationTransition});
                      },false);


                      // seulement si l'état "ended" existe pour cette pièce
                      if(videoAssortimentended != null)
                      {
                          // Etat 3 -> ended
                          videoAssortimentended.addEventListener('play', function () { 
                              currentState = 2;

                              gsap.to(videoAssortimentReverse,{opacity:0,duration:0.8});
                              gsap.to(videoAssortiment,{opacity:0,duration:0.8});
                              gsap.to(videoAssortimentended,{opacity:1,duration:0.4});

                              videoAssortimentended.playbackRate = 1;
                              videoAssortimentended.loop = true;
                          },false);
                      }

                      // Gestion des animation en cours
                      videoAssortiment.addEventListener('ended', function () { 
                          // l'animation est terminée
                          videoAssortimentPlayed = false;
                          if(videoAssortimentended != null)
                          {

                            setTimeout(() => {
                              videoAssortimentended.play();
                            },100);
                            
                            
                          }

                      });
                      videoAssortimentReverse.addEventListener('ended', function () {
                          // l'animation est terminée
                          videoAssortimentReversePlayed = false;
                      });
                  } /* end if(!isMobile) */

                  var startAnim = (isMobile)?'top 55%':'top 55%';
                  let wrapper = item.querySelector(".animVid");


                  if(!isMobile)
                  {
                      ScrollTrigger.create({
                        trigger: wrapper,
                        start: startAnim,
                        end: "top top",
                        markers: debug,
                        onEnter: self => { assortimentsPlay(0); },
                        onLeave: self => { assortimentsPlay(1); },
                        onLeaveBack: self => { assortimentsReverse(1); },
                        onEnterBack: self => { assortimentsReverse(0); }
                      });

                      function assortimentsPlay(leave){
                        // Es-ce que l'animation précèdente est terminée ?

                        if(!currentState)
                        {
                          if(videoAssortimentReversePlayed)
                            videoAssortiment.currentTime = (videoAssortimentReverse.duration-videoAssortimentReverse.currentTime);                          
                          else
                            videoAssortiment.currentTime = 0; 
                          videoAssortimentReverse.pause();
                          if(videoAssortimentended != null)
                            videoAssortimentended.pause();
                          // animation en cours
                          videoAssortimentPlayed = true;
                          setTimeout(() => {
                            videoAssortiment.play();
                          },100);
                        }
                      }
                      function assortimentsReverse(leave){
                          if(currentState)
                          {
                              // Es-ce que l'animation précèdente est terminée ?
                              if(videoAssortimentPlayed)
                                  videoAssortimentReverse.currentTime = (videoAssortiment.duration-videoAssortiment.currentTime);
                              else
                                  videoAssortimentReverse.currentTime = 0; 
                              videoAssortiment.pause();
                              if(videoAssortimentended != null)
                                videoAssortimentended.pause();
                              videoAssortimentReversePlayed = true;
                              setTimeout(() => {
                                  videoAssortimentReverse.play();
                              },100);
                          }
                      }
                  } /* en if !isMobile */

                  /* On ignore le 1er container pour la gestion des titres */
                  if ( index !== 0) {
                    ScrollTrigger.create({
                        trigger: item,
                        start: "top center",
                        end: "bottom center",
                        markers: debug,
                        onEnter: self => swiperChapitreAssortiments.slideNext(),
                        onLeaveBack: self => swiperChapitreAssortiments.slidePrev(),
                    });
                  }
              });    
              loadVidAssortiment = true;
            }




            /* Animations chapitre 09 - Horlogerie */
           
            let tlChapitreHorlogerie = gsap.timeline({
                scrollTrigger : {
                    trigger: '#chapitreHorlogerie',
                    start: "top top",
                    end:"+=4500",
                    pin:'.media',
          /*      TOODOO     pinSpacing:false, */
                    scrub:true,
                    onLeave: ({progress, direction, isActive}) => 
                    {
                      tlHideShowNav.reverse(); 
                    },
                    onEnterBack:({progress, direction, isActive}) => 
                    {
                      tlHideShowNav.paused(false);
                      tlHideShowNav.play();
                    }
                }
            })
            .to('#chapitreHorlogerie .rideau',{height:'100vh',duration:1})
            .fromTo('#chapitreHorlogerie .full-img',{clipPath:'inset(0% 50% 0% 50%)',ease: 'power2.In'},{clipPath:'inset(0% 0% 0% 0%)',ease: 'power2.In',duration:1})
            .to('#vidHor',{opacity:1})
            .fromTo('#chapitreHorlogerie .media .hideEnd',{clipPath: "inset(0% 0% 0% 0%)"},{clipPath: "inset(0% 100% 0% 0%)"});

            /* Animations de swiper section finitions */
            const itemDecoration = gsap.utils.toArray("#chapitreFinitions .item-decoration");

            var start = 0;
            var end = 0;
            itemDecoration.forEach((item, index) => {
            
            end = item.offsetHeight+end;
            let swiperFlipFlop = item.querySelector(".swiper-flip-flop");
            const currentSwiper = swiperFlipFlop.swiper;
            //gsap.set(item,{opacity:0});
            let text = item.querySelector('.card');
            let push;
            let yP;

            if (isMobile) {
              push = (item.classList.contains('left'))?'0%':'0%';
              yP = 0;
              start = "center top+=60%";
              end = "center top+=40%";
            } else {
              push = (item.classList.contains('left'))?'-8%':'+8%';
              gsap.set(swiperFlipFlop, {yPercent: -40});
              yP = 40;
              start = "center top+=60%";
              end = "center top+=30%";
            }
            
            gsap.set(text, {x: push});
            let spacing = (item.classList.contains('deco-end'))?true:false;
            let opacityEnd = (item.classList.contains('deco-end'))?1:0;

            gsap.timeline({
              scrollTrigger: {
                trigger: swiperFlipFlop,
                start: start,
                end: end,
                markers: false,
                pinSpacing: spacing,
                scrub:1,                        
                onEnter: self => currentSwiper.slideNext(),
                onEnterBack: self => currentSwiper.slidePrev(),
                onLeave: self => currentSwiper.slideNext(),
                onLeaveBack: self => currentSwiper.slidePrev(),
              }
            });
            start = start+item.offsetHeight;

            gsap.timeline({
            scrollTrigger: {
              trigger: item,
              start: "top bottom",
              end: "bottom top",
              markers: false,
              scrub: true,
            }
          }).to(swiperFlipFlop, {yPercent: yP, ease: "none"});
        }); 









        

            /* Gestion des chapitres */
            const chapters = gsap.utils.toArray(".chapter");
            const navLink = gsap.utils.toArray(".custom-nav li");

            chapters.forEach((chapter, index) => {

                let chapterHeight = chapter.offsetHeight;

                /* Test s'il y a un chapitre après celui actuel */
                let endTrigger = (chapters[index+1] !== undefined) ? chapters[index+1] : 'body';
                //let end = (chapters[index+1] !== undefined) ? "top top" : 'bottom bottom';
                //let end = (chapters[index+1] !== undefined) ? 'top top+='+chapterHeight+'px' : 'bottom bottom'; 
                let end = (chapters[index+1] !== undefined) ? 'top 0%+='+chapterHeight+'px' : 'bottom bottom'; 

                ScrollTrigger.create({
                    trigger: chapter,
                    start: 'top top',
                    endTrigger: endTrigger,
                    end:'top top',
                    markers: debug,
                    onToggle: self => {
                      navLink[index].classList.toggle('active');
                    }
                });

                

                ScrollTrigger.create({
                    trigger: chapter,
                    start: 'top top',
                    endTrigger: endTrigger,
                    end:end,
                    pin: chapter,
                    invalidateOnRefresh: true,
                    pinSpacing: false, 
                    markers: debug,
                    onToggle: self => {
                      if(!isMobile)
                      {
                        // Gestion des changements de background entre différentes sections
                        switch (index) {
                          case 0:
                              document.querySelector("#generalBG #spiral").classList.remove("active");
                              document.querySelector("#generalBG #outlineC").classList.add("active");
                              document.querySelector("#generalBG #lines").classList.remove("active");
                              document.querySelector("#generalBG #outlineCSmall").classList.remove("active");
                          break;
                          case 1:
                              // chargement des vidéos
                              if(!loadVidAssortiment)
                                  videoAssortiment();

                              document.querySelector("#generalBG #spiral").classList.remove("active");
                              document.querySelector("#generalBG #outlineC").classList.add("active");
                              document.querySelector("#generalBG #lines").classList.remove("active");
                              document.querySelector("#generalBG #outlineCSmall").classList.remove("active");
                          break;
                          case 2:
                            
                            document.querySelector("#generalBG #spiral").classList.add("active");
                            document.querySelector("#generalBG #outlineC").classList.remove("active");
                            document.querySelector("#generalBG #lines").classList.remove("active");
                            document.querySelector("#generalBG #outlineCSmall").classList.remove("active");
                          break;
                          case 4: 
                            document.querySelector("#generalBG #spiral").classList.add("active");
                            document.querySelector("#generalBG #outlineC").classList.remove("active");
                            document.querySelector("#generalBG #lines").classList.remove("active");
                            document.querySelector("#generalBG #outlineCSmall").classList.remove("active");
                          break;
                          case 5:
                            document.querySelector("#generalBG #spiral").classList.remove("active");
                            document.querySelector("#generalBG #outlineC").classList.remove("active");
                            document.querySelector("#generalBG #lines").classList.add("active");
                            document.querySelector("#generalBG #outlineCSmall").classList.remove("active");
                          break;
                          case 6:
                            document.querySelector("#generalBG #spiral").classList.remove("active");
                            document.querySelector("#generalBG #outlineC").classList.remove("active");
                            document.querySelector("#generalBG #lines").classList.remove("active");
                            document.querySelector("#generalBG #outlineCSmall").classList.add("active");
                          break;
                          case 7:
                            document.querySelector("#generalBG #spiral").classList.remove("active");
                            document.querySelector("#generalBG #outlineC").classList.remove("active");
                            document.querySelector("#generalBG #lines").classList.remove("active");
                            document.querySelector("#generalBG #outlineCSmall").classList.add("active");
                          break;
                          case 8:
                            document.querySelector("#generalBG #spiral").classList.remove("active");
                            document.querySelector("#generalBG #outlineC").classList.add("active");
                            document.querySelector("#generalBG #lines").classList.remove("active");
                            document.querySelector("#generalBG #outlineCSmall").classList.remove("active");
                          break;
                        }
                      } else
                      {
                        // Gestion des changements de background entre différentes sections
                        switch (index) {
                          case 1:
                              // chargement des vidéos
                              if(!loadVidAssortiment)
                                videoAssortiment();
                          break;
                        }
                      }
                    }
                });
              });

              

            /* Gestion des menus */
            navLink.forEach((li, index) => {

                let a = li.querySelector('a');
                a.addEventListener("click", function(e) {
                    e.preventDefault();
                    gsap.to(window, {
                        duration: 0.8,
                        scrollTo: {
                        y: e.target.getAttribute("href"),  
                        offsetY: -1
                        }
                    });
                });
            });


  
            
            /* Animation outlineC */
            let animationBG = gsap.timeline({
              paused: false,
          }).to("svg#outlineC g", {
              duration: 80,
              repeat: -1,
              ease: "none",
              motionPath:{
                  path: "svg#outlineC path",
                  align: "svg#outlineC path",
                  start:  0.25,
                  end: 1.2499,
                  alignOrigin: [0.5, 0.5],
              }
          });
          var initialScale = 1;
          var maxScale = 1.4;

          gsap.set("svg#outlineC g circle.c1", {scale:initialScale,opacity:1, transformOrigin:"center center"});
          gsap.set("svg#outlineC g circle.c2", {scale:initialScale,opacity:0.8, transformOrigin:"center center"});
          gsap.set("svg#outlineC g circle.c3", {scale:initialScale,opacity:0.6, transformOrigin:"center center"});
          
          var ease = "back.inOut(5)";

          var tlcec1 = gsap.timeline({repeat: -1, delay:0, yoyo:1});
          tlcec1.to("svg#outlineC g circle.c1", {scale:maxScale, transformOrigin:"center center",duration:5, ease: ease});

          var tlcec2 = gsap.timeline({repeat: -1, delay: 0.4, yoyo:1});
          tlcec2.to("svg#outlineC g circle.c2", {scale:maxScale, transformOrigin:"center center",duration:5,ease: ease});

          var tlcec3 = gsap.timeline({repeat: -1, delay: 0.8, yoyo:1});
          tlcec3.to("svg#outlineC g circle.c3", {scale:maxScale, transformOrigin:"center center",duration:5,ease: ease});

         
         if(!isMobile)
         {
          /* Animation spirale */
          gsap.to("#spiral", {rotation: 360, duration: 200, repeat: -1, ease: "none"});

          /* Animation lines */
          var viewport_width = window.innerWidth;
          var xtrans = viewport_width*0.25;
          let animLine = gsap.to("#lines", {duration:40,x:'+='+xtrans,ease: "none"});
          let tlline = gsap.timeline({ repeat:-1, repeatRefresh: false});
          tlline.add(animLine);

          //gsap.to("#lines", {xPercent: 100, duration: 100, repeat: -1, ease: "none"});

          /* Animation outlineCSmall */
          gsap.to("#outlineCSmall", {xPercent: 100, duration: 30, repeat: -1, ease: "none"});
         }




          /* Gestion des transitions fond */
          const transitions = gsap.utils.toArray(".transition");

          transitions.forEach((transition, index) => {

              let end = (transitions[index+1] !== undefined) ? "bottom center" : '+1000000px'; 

              let bgColorClass = transition.dataset.bgColor;
              ScrollTrigger.create({
                  trigger: transition,
                  start: 'top center',
                  end: end,
                  markers: debug,
                  toggleClass: {targets: "body", className: bgColorClass}
              });

          });
          
          
          /* ################################################################################### */
        /* #################          Gestion des vidéos (VIMEO.JS)       #################### */
        /* ################################################################################### */


          /* DTR */
          var DTRInitialized = false;
          var DTROptions = {
            url : 'https://vimeo.com/813534442/f00f932a95',
            loop : true,
            muted : true,
            background : 1,
            autoplay :true,
            responsive : true,
            quality : 'auto',
          };
          ScrollTrigger.create({
            trigger: "#chapitreDTR",
            start: "top bottom",
            onToggle: self => {
              if(!DTRInitialized)
              {
/*                 console.log('play DTR'); */
                const videoDTRPlayer = new Vimeo.Player('vidDTR',DTROptions)
                DTRInitialized = true;
              }
            }
          });


          //const videoDTRPlayer = new Vimeo.Player('vidDTR',DTROptions);


          /* ART & DESIGN */
          var ADInitialized = false;
          var ADOptions = {
              url : 'https://vimeo.com/813507149/088e2fcc6f',
              loop : true,
              muted : true,
              background : 1,
              autoplay :true,
              responsive : true,
              quality : 'auto',
          };
          ScrollTrigger.create({
            trigger: "#chapitreDecoration",
            start: "top bottom",
            onToggle: self => {
              if(!ADInitialized)
              {
                
                const videoADPlayer = new Vimeo.Player('vidAD',ADOptions);
                videoADPlayer.on('play', function() {
                  /* console.log('play AD'); */
                  // Trigger the CSS animation by adding the "start" class to the "marquee-track" element
                  gsap.to('#vidAD',{clipPath:'inset(0% 0% 0% 0% round 25px)', duration:0.8});
                });
                ADInitialized = true;
              }
            }
          });



        /* HORLOGERIE */
        var HORInitialized = false;
        var HorOption = {
            url : 'https://vimeo.com/886365101/5fadb40199',
            loop : true,
            muted : true,
            background : 1,
            autoplay :true,
            responsive : true,
            quality : 'auto',
        };
        ScrollTrigger.create({
          trigger: "#chapitreHorlogerie",
          start: "top bottom",
          onToggle: self => {
            if(!HORInitialized)
            {
              const videoHorPlayer = new Vimeo.Player('vidHor',HorOption);
              HORInitialized = true;
            }
          }
        });
        



        }
      });


});

/* Page historique/chronologie */
if ( historique !== null ) {
	/* Historique */
	var vid2015Options = {
	url : 'https://vimeo.com/834189009/0976e7dfdc',
	loop : true,
	muted : true,
	background : true,
	autoplay : false,
	responsive : true,
	quality : '1080p',
	autopause : false,
	};

	
	var videoHistorique2015Player = new Vimeo.Player('vid2015', vid2015Options);
/* 	videoHistorique2015Player.pause();

	ScrollTrigger.create({
	trigger: '#video2015Container',
	start: "top center",
	end: "bottom center",
	onEnter: ({progress, direction, isActive}) =>  videoHistorique2015Player.play(),
	onEnterBack: ({progress, direction, isActive}) =>  videoHistorique2015Player.play(),
	onLeave: ({progress, direction, isActive}) =>  videoHistorique2015Player.pause(),
	onLeaveBack: ({progress, direction, isActive}) =>  videoHistorique2015Player.pause()
	});  */

	ScrollTrigger.create({
	trigger: '#timelineChrono',
	start: "center center",
	end: "center center",
	endTrigger: ".last-item-chronologie",
	pin:'#timelineChrono',
	pinSpacing: false,
	pinSpacer: false,
	}); 
}

/**************************************************************************
 **************************************************************************
 ************************* GESTION DE SWIPER ******************************
 **************************************************************************
 ***************************************************************************/

/* Swiper méthodes */
let swiperMethodes = new Swiper(".swiper-methodes", {
    loop: false,
    grabCursor: true,
    allowTouchMove:true,
    effect: "creative",
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    creativeEffect: {
        prev: {
            shadow: false,
            translate: ["0%", 0, -1],
            origin: "center center",
        },
        next: {
            shadow: false,
            translate: ["100%", 0, 0],
            origin: "center center",
        },
    },
});


/* Swiper fabrication */
new Swiper(".swiper-fabrication", {
    loop: true,
    allowTouchMove:false,
    spaceBetween: 0,
    slidesPerView: 1,
    autoplay: {
        delay: 1,
        disableOnInteraction: true
    },
    speed: 3000,
    
    breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 0,
          speed: 7000,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 0,
          speed: 14000,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
          speed: 14000,
        },
    },
});

/* Swiper fabrication 2 */
let swiperPaginationBullet = document.getElementsByClassName("spbf2");

let swiperFabrication2 = new Swiper(".swiper-fabrication-2", {
    loop: true,
    grabCursor: true,
    effect: "creative",
    rebuildOnUpdate: true,
    pagination: {
        el: '.sbf',
        type: 'bullets',
        clickable: true
      },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    creativeEffect: {
        prev: {
            shadow: false,
            translate: ["0%", 0, -1],
            origin: "center center",
        },
        next: {
            shadow: false,
            translate: ["100%", 0, 0],
            origin: "center center",
        },
    },
});

/* Gestion custom du slider "150 unités d'usinage" */
swiperFabrication2.on('slideChangeTransitionStart', function () {
  switch (swiperFabrication2.realIndex) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
          swiperPaginationBullet[0].classList.add("swiper-pagination-bullet-active");
          swiperPaginationBullet[1].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[2].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[3].classList.remove("swiper-pagination-bullet-active");
      break;
      case 5:
      case 6:
          swiperPaginationBullet[1].classList.add("swiper-pagination-bullet-active");
          swiperPaginationBullet[0].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[2].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[3].classList.remove("swiper-pagination-bullet-active");
          break;
      case 7:
          swiperPaginationBullet[2].classList.add("swiper-pagination-bullet-active");
          swiperPaginationBullet[1].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[0].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[3].classList.remove("swiper-pagination-bullet-active");
          break;
      case 8:
          swiperPaginationBullet[3].classList.add("swiper-pagination-bullet-active");
          swiperPaginationBullet[0].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[1].classList.remove("swiper-pagination-bullet-active");
          swiperPaginationBullet[2].classList.remove("swiper-pagination-bullet-active");
          break;
      default:
          break;
  }
});

/* Gestion de l'event click du slider "150 unités d'usinage" */
let sliderLinks = document.querySelectorAll(".swiper-pagination-bullet");

sliderLinks.forEach( function(sliderLink) {
    let sliderLinkData = sliderLink.dataset.paginationIndex;
    sliderLink.addEventListener("click", function(e) {
      if(typeof sliderLinkData !== 'undefined')
      {
        // SlideToLoop and not slideTo when used loop mode!!!
        swiperFabrication2.slideToLoop(sliderLinkData);
      }
    })
});

/* Swiper chapter 06 - Échappements */
new Swiper(".swiper-chapitre-assortiments", {
    spaceBetween: 100,
    slidesPerView: "auto",
    allowTouchMove : false,
    centeredSlides: true,
});

/* Swiper flip-flop */
new Swiper(".swiper-flip-flop", {
    effect: "creative",
    freeMode: false,
    allowTouchMove : false,
    creativeEffect: {
        prev: {
            shadow: false,
            translate: ["-20%", 0, -1],
            origin: "right center",
        },
        next: {
            shadow: false,
            translate: ["100%", 0, 0],
            origin: "left center",
        },
    },
});


/**************************************************************************
 **************************************************************************
 ************************* GESTION DU MENU ********************************
 **************************************************************************
 ***************************************************************************/

let openMenuButton = document.querySelector("#openMenuButton");
let closeMenuButton = document.querySelector("#closeMenuButton");
let fullpageMenu = document.querySelector("#fullpageMenu");

let closeMenuButton2 = document.querySelector("#closeMenuButton2");
let fullpageMenu2 = document.querySelector("#fullpageMenu2");

// TODO GESTION DES TEXTES AVEC SPLITTEXT
/* let menuItems = gsap.utils.toArray(".menu-item");

menuItems.forEach((item, index) => {
    var splitText = new SplitText(item, {type: "chars"});

    gsap.timeline({}).from(splitText.chars, {duration: 0.32, opacity:0, y:30, stagger: .02,  ease: 'power4.In'}); 
}); */


openMenuButton.addEventListener("click", function(e){
    gsap.to(fullpageMenu, {xPercent: -100, duration: 0.5, ease: "power2.out"});
})

closeMenuButton.addEventListener("click", function(e){
    gsap.to(fullpageMenu, {xPercent: 100, duration: 0.5, ease: "power2.in"});
})




  /**************************************************************************
   **************************************************************************
  ************************* GOOGLE MAP ********************************
  **************************************************************************
  ***************************************************************************/

  
  if ( contact !== null ) {

    // Initialize and add the map
    function initMap() {
      // The location of Uluru
      const location = { lat: 47.110955, lng: 6.8391869 };
      // The map, centered at Uluru
      const gmap = new google.maps.Map(document.getElementById("gmap"), {
        zoom: 15,
        center: location,
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
        },
        styles:
          [
              {
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#212121"
                  }
                ]
              },
              {
                "elementType": "labels.icon",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#757575"
                  }
                ]
              },
              {
                "elementType": "labels.text.stroke",
                "stylers": [
                  {
                    "color": "#212121"
                  }
                ]
              },
              {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#757575"
                  }
                ]
              },
              {
                "featureType": "administrative.country",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#9e9e9e"
                  }
                ]
              },
              {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#bdbdbd"
                  }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#757575"
                  }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#181818"
                  }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#616161"
                  }
                ]
              },
              {
                "featureType": "poi.park",
                "elementType": "labels.text.stroke",
                "stylers": [
                  {
                    "color": "#1b1b1b"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                  {
                    "color": "#2c2c2c"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#8a8a8a"
                  }
                ]
              },
              {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#373737"
                  }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#3c3c3c"
                  }
                ]
              },
              {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#4e4e4e"
                  }
                ]
              },
              {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#616161"
                  }
                ]
              },
              {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#757575"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                  {
                    "color": "#000000"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#3d3d3d"
                  }
                ]
              }
            ]
      });

      var uploadUrl = document.querySelector("body").dataset.upload;

      // Custom size icon for the marker
      var icon = {
        url: uploadUrl + "/marker.png", // url
        scaledSize: new google.maps.Size(50, 50), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(0, 0) // anchor
      }

      // The marker, positioned at Uluru
      const marker = new google.maps.Marker({
        position: location,
        map: gmap,
        icon: icon
      });

      // The info window
      const infowindow = new google.maps.InfoWindow({
        content: "Concepto Watch Factory SA<br> Rue du Collège 85 <br> 2301 La Chaux-de-Fonds <br> <a href='https://www.google.com/maps/dir//Concepto+Watch+Factory+SA,+Rue+du+Coll%C3%A8ge,+La+Chaux-de-Fonds/@47.1111437,6.8009481,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x478dfb66f12f65e9:0x2508ff996801b630!2m2!1d6.8421886!2d47.1110851' target='_blank' style='text-decoration: underline; font-weight: bold;'>Itinéraire</a>",
      });

      // Click event on the marker
      marker.addListener("click", () => {
        infowindow.open({
          anchor: marker,
          gmap,
        });
      });

    }
    window.initMap = initMap;
  }